export interface CuratedOrganization {
  catchphrase?: string;
  date: string;
  description: string;
  display: boolean;
  email?: string;
  id: string;
  latitude: number;
  location: string;
  longitude: number;
  organization: string;
  partnerSince: string;
  phone?: string;
  photoUrl?: string;
  quotes?: string[];
  schoolName?: string;
  type: string;
}

export const emptyMayTerm: CuratedOrganization = {
  catchphrase: "",
  date: "",
  description: "",
  display: true,
  email: "",
  id: "",
  latitude: 0,
  location: "",
  longitude: 0,
  organization: "",
  partnerSince: "",
  phone: "",
  photoUrl: "",
  quotes: [],
  schoolName: "",
  type: "",
};

export const emptyPartnerSchool: CuratedOrganization = {
  catchphrase: "",
  date: "",
  description: "",
  display: true,
  email: "",
  id: "",
  latitude: 0,
  location: "",
  longitude: 0,
  organization: "",
  partnerSince: "",
  phone: "",
  photoUrl: "",
  quotes: [],
  schoolName: "",
  type: "",
};
